import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ExpandedCardsSystem from '../../../../../../../expandedCardsSystem/ExpandedCardsSystem'
import CustomCircularProgress from '../../../../../../../smallComponents/CustomCircularProgress'
import TitleHeader from '../../../../../../../smallComponents/Header'
import MultiLangNumber from '../../../../../../../smallComponents/MultiLangNumber'
import GlobalInquiryRequestDetails from './GlobalInquiryRequestsComps/GlobalInquiryRequestDetails'

const GlobalInquiryRequests = ({ DCGProps, globalInquiry }) => {
  //  any contribution requests and the content of the contribution request may be some more ideas or something added
  const { t } = useTranslation()
  const { project } = DCGProps
  const [requests, setRequests] = useState([])
  const [requestsUsers, setRequestsUsers] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const fetchRequests = async () => {
      setIsLoading(true)
      try {
        const res = await axios.get(
          `/requests/elementRequests/${globalInquiry?._id}`
        )
        setRequests(res.data.requests)
        setRequestsUsers(res.data.requestsUsers)
      } catch (error) {
        console.log(error)
      }
      setIsLoading(false)
    }
    fetchRequests()
  }, [project?._id])
  return isLoading ? (
    <CustomCircularProgress />
  ) : (
    <>
      <TitleHeader
        headerText={`${MultiLangNumber(requests?.length)} ${t('Requests')}`}
      />
      <ExpandedCardsSystem
        cards={requests}
        UnitCardDetailsComponent={GlobalInquiryRequestDetails}
        firsButtonConfigs={{
          hideButton: true,
          props: {
            globalInquiry,
          },
        }}
        searchSystemProps={{}}
        DCGProps={DCGProps}
        requestsUsers={requestsUsers}
        setRequests={setRequests}
      />
    </>
  )
}

export default GlobalInquiryRequests
